var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrResultGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FR details") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New-design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-104.000000, -448.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FR-details",
    transform: "translate(104.000000, 448.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#68AC58",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    rx: 2.66666667
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/photo-stack",
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-2",
    transform: "translate(4.400000, 4.400000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 14.4,
    height: 14.4,
    rx: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2,8.20598802 C7.69501246,8.20598802 8.2379212,8.27784359 8.82874251,8.42155689 C9.49940455,8.5892224 10.0423133,8.81277305 10.457485,9.09221557 C10.9524975,9.41956251 11.2,9.78682431 11.2,10.194012 L11.2,11.2 L3.2,11.2 L3.2,10.194012 C3.2,9.78682431 3.44750251,9.41956251 3.94251497,9.09221557 C4.35768671,8.81277305 4.90059545,8.5892224 5.57125749,8.42155689 C6.1620788,8.27784359 6.70498754,8.20598802 7.2,8.20598802 Z M7.2,7.2 C6.84071677,7.2 6.50938275,7.11018054 6.20598802,6.93053892 C5.90259329,6.75089731 5.66107874,6.50938275 5.48143713,6.20598802 C5.30179551,5.90259329 5.21197605,5.57125928 5.21197605,5.21197605 C5.21197605,4.85269281 5.30179551,4.51736683 5.48143713,4.20598802 C5.66107874,3.89460922 5.90259329,3.64910269 6.20598802,3.46946108 C6.50938275,3.28981946 6.84071677,3.2 7.2,3.2 C7.55928323,3.2 7.89061725,3.28981946 8.19401198,3.46946108 C8.49740671,3.64910269 8.73892126,3.89460922 8.91856287,4.20598802 C9.09820449,4.51736683 9.18802395,4.85269281 9.18802395,5.21197605 C9.18802395,5.57125928 9.09820449,5.90259329 8.91856287,6.20598802 C8.73892126,6.50938275 8.49740671,6.75089731 8.19401198,6.93053892 C7.89061725,7.11018054 7.55928323,7.2 7.2,7.2 Z",
    id: "icon/person/black",
    fill: "#5f00a0",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy",
    transform: "translate(2.400000, 2.400000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#68AC58",
    strokeWidth: 0.5,
    fill: "#FFFFFF",
    x: 0.25,
    y: 0.25,
    width: 13.9,
    height: 13.9,
    rx: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2,8.20598802 C7.69501246,8.20598802 8.2379212,8.27784359 8.82874251,8.42155689 C9.49940455,8.5892224 10.0423133,8.81277305 10.457485,9.09221557 C10.9524975,9.41956251 11.2,9.78682431 11.2,10.194012 L11.2,11.2 L3.2,11.2 L3.2,10.194012 C3.2,9.78682431 3.44750251,9.41956251 3.94251497,9.09221557 C4.35768671,8.81277305 4.90059545,8.5892224 5.57125749,8.42155689 C6.1620788,8.27784359 6.70498754,8.20598802 7.2,8.20598802 Z M7.2,7.2 C6.84071677,7.2 6.50938275,7.11018054 6.20598802,6.93053892 C5.90259329,6.75089731 5.66107874,6.50938275 5.48143713,6.20598802 C5.30179551,5.90259329 5.21197605,5.57125928 5.21197605,5.21197605 C5.21197605,4.85269281 5.30179551,4.51736683 5.48143713,4.20598802 C5.66107874,3.89460922 5.90259329,3.64910269 6.20598802,3.46946108 C6.50938275,3.28981946 6.84071677,3.2 7.2,3.2 C7.55928323,3.2 7.89061725,3.28981946 8.19401198,3.46946108 C8.49740671,3.64910269 8.73892126,3.89460922 8.91856287,4.20598802 C9.09820449,4.51736683 9.18802395,4.85269281 9.18802395,5.21197605 C9.18802395,5.57125928 9.09820449,5.90259329 8.91856287,6.20598802 C8.73892126,6.50938275 8.49740671,6.75089731 8.19401198,6.93053892 C7.89061725,7.11018054 7.55928323,7.2 7.2,7.2 Z",
    id: "icon/person/black",
    fill: "#5f00a0",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#68AC58",
    strokeWidth: 0.5,
    fill: "#FFFFFF",
    x: 0.25,
    y: 0.25,
    width: 13.9,
    height: 13.9,
    rx: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2,8.20598802 C7.69501246,8.20598802 8.2379212,8.27784359 8.82874251,8.42155689 C9.49940455,8.5892224 10.0423133,8.81277305 10.457485,9.09221557 C10.9524975,9.41956251 11.2,9.78682431 11.2,10.194012 L11.2,11.2 L3.2,11.2 L3.2,10.194012 C3.2,9.78682431 3.44750251,9.41956251 3.94251497,9.09221557 C4.35768671,8.81277305 4.90059545,8.5892224 5.57125749,8.42155689 C6.1620788,8.27784359 6.70498754,8.20598802 7.2,8.20598802 Z M7.2,7.2 C6.84071677,7.2 6.50938275,7.11018054 6.20598802,6.93053892 C5.90259329,6.75089731 5.66107874,6.50938275 5.48143713,6.20598802 C5.30179551,5.90259329 5.21197605,5.57125928 5.21197605,5.21197605 C5.21197605,4.85269281 5.30179551,4.51736683 5.48143713,4.20598802 C5.66107874,3.89460922 5.90259329,3.64910269 6.20598802,3.46946108 C6.50938275,3.28981946 6.84071677,3.2 7.2,3.2 C7.55928323,3.2 7.89061725,3.28981946 8.19401198,3.46946108 C8.49740671,3.64910269 8.73892126,3.89460922 8.91856287,4.20598802 C9.09820449,4.51736683 9.18802395,4.85269281 9.18802395,5.21197605 C9.18802395,5.57125928 9.09820449,5.90259329 8.91856287,6.20598802 C8.73892126,6.50938275 8.49740671,6.75089731 8.19401198,6.93053892 C7.89061725,7.11018054 7.55928323,7.2 7.2,7.2 Z",
    id: "icon/person/black",
    fill: "#68AC58",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon/person/person_black",
    transform: "translate(8.800000, 12.800000)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrResultGreen);
export default __webpack_public_path__ + "static/media/fr_result_green.c9a4f1f0209b76e1aaf02e93b8627c6f.svg";
export { ForwardRef as ReactComponent };